(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('httpConflictHandler', httpConflictHandler);

    function httpConflictHandler($injector, $window, $q, $translate, $log, $state, logger, config) {
        return {
            responseError: function (response) {
                var message;

                // Handle error unless it is expected or there are no expected errorcodes
                if (!angular.isArray(response.config.expectedHttpErrorCodes) ||
                    response.config.expectedHttpErrorCodes.indexOf(response.status) === -1 &&
                    response.config.expectedHttpErrorCodes !== '*') {

                        $log.error('httpConflictHandler', response);

                        var title = null;
                        message = null;
                    
                        switch (response.status) {
                            case 409:
                                title = $translate.instant('error_while_saving');
                                message = $translate.instant('saving_this_record_failed_because_it_was_updated_by_someone_else');
                                break;
                            case 500:
                                title = $translate.instant('error');
                                message = $translate.instant('a_problem_occurred');
                                break;
                            case 503:
                                config.settings = {
                                    maintenance: { status: 'on', message: response.data }
                                };
                                $state.go('maintenance');
                                return;
                            default:
                                break;
                        }

                        if (response.status >= 400) {
                            if (typeof exceptionless !== 'undefined') {                                try {
                                    exceptionless.ExceptionlessClient.default.createLog("SkillUI.httpConflictHandler", "Error when sending request: " + response.status, "error")
                                        .setProperty("response", response)
                                        .submit();
                                }
                                catch (err) {
                                    exceptionless.ExceptionlessClient.default.createLog("SkillUI.httpConflictHandler", "Error when logging error")
                                        .setProperty("error", err)
                                        .submit();
                                }
                            }
                        }
                        if (message) {
                            var modalDialogService = $injector.get('modalDialogService');
                            return modalDialogService.alert(title, message).result.then(() => { $window.location.reload(); });
                        }
                }

                message = (response.data && response.data.message) ? response.data.message : response.statusText;
                if (message) {
                    logger.error(message);
                }

                return $q.reject(response);
            }
        };
    }
})();